import { Component, Inject, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { AppMessageService } from 'src/app/services/app-message.service';

@Component({
  selector: 'src-ext-lov',
  templateUrl: './src-ext-lov.component.html',
  styleUrls: ['./src-ext-lov.component.css']
})
export class SrcExtLovComponent implements OnInit {

  srcExtModuleId: string = 'BMM056';

  constructor(private apiCallService: APICallService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService,
    private userDetailService: UserDetailsService,
    private appMessageService: AppMessageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<SrcExtLovComponent>
  ) {
    this.srcExtTableConfig.cols = (this.data.col === 'CD') ? this.srcExtColsCd : this.srcExtColsBm;
    this.getSrcExt();
  }

  ngOnInit(): void {

  }

  // Variable Initializer
  srcExtData: any = [];
  srcExtColsCd: any[] = [
    {
      key: "SRC_EXT_CD",
      header: "Source Ext Code",
      dataType: "string"
    },
    {
      key: "SRC_EXT_DESC",
      header: "Source Extension",
      dataType: "string"
    }
  ];

  srcExtColsBm: any[] = [
    {
      key: "BM_CODE",
      header: "Source Ext Code",
      dataType: "string"
    },
    {
      key: "SRC_EXT_DESC",
      header: "Source Extension",
      dataType: "string"
    }
  ];

  // Source Extension Initializer
  srcExtTableConfig: any = {
    cols: [],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15
  }

  // Gets data for Source Extension Table
  async getSrcExt() {
    try {
      /*
      this.srcExtTableConfig.loading = true;
      this.srcExtData = await this.apiCallService.getAllSourceExtension().toPromise();
      this.srcExtData = this.srcExtData.content;
      this.srcExtTableConfig.loading = false;
      this.srcExtTableConfig.tblData = this.srcExtData;
      */
      this.srcExtTableConfig.loading = true;
      this.jsonDataService.contorlLoading(true);
      this.apiCallService.getAllSourceExtension({
        moduleId: this.data.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe((response: any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, () => {
            if (response.status === 'SUCCESS') {
              let data = JSON.parse(this.jsonDataService.decrypt(response.response));
              if (data.moduleId === this.srcExtModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.srcExtTableConfig.loading = false;
                this.srcExtTableConfig.tblData = data.data?.filter((rows: any) => !(this.data.srcExtsExclude ?? []).includes(rows.SRC_EXT_CD)).sort((a: any, b: any) => (a.SRC_EXT_CD > b.SRC_EXT_CD) ? 1 : -1).filter((a: any) => a.ACTIVE_TAG === 'A');
                if (this.data.lpad) {
                  this.srcExtTableConfig.tblData = this.srcExtTableConfig.tblData?.map((c: any) => { return { ...c, SRC_EXT_CD: parseInt(c.SRC_EXT_CD)?.toString().padStart(this.data?.lpad, "0") } });
                }
                if (this.data?.srcExtExclude) {
                  this.srcExtTableConfig.tblData = this.srcExtTableConfig.tblData.filter((d: any) => (!((this.data.srcExtExclude ?? []).includes(+d.SRC_EXT_CD))));
                }
              } else {
                this.jsonDataService.contorlLoading(false);
                this.srcExtTableConfig.loading = false;
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            } else {
              this.jsonDataService.contorlLoading(false);
              this.srcExtTableConfig.loading = false;
              this.appMessageService.showAppMessage(response.message, "error");
            }
          });
        });
      });
    }
    catch (e) {
    console.error(e);

    }
  }

  onRowClick(ev: any) {
    try {
      this.data = ev;
    }
    catch (e) {
    console.error(e);

    }
  }

  onClose() {
    try {
      if (this.data == '' || this.data == null) {
        this._dialogRef.close({ content: '' });
      } else {
        this._dialogRef.close({ content: this.data });
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  onBack() {
    try {
      this._dialogRef.close({ content: '', option: 'back' });
    }
    catch (e) {
    console.error(e);

    }
  }

}
